/* src/app/core/modules/shared/components/full-iframe/full-iframe.component.scss */
.iframe-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: var(--ion-background-color);
  animation: jumpFromBottom 0.3s;
}
.iframe-wrapper iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: none;
}
/*# sourceMappingURL=/avvera/dev/full-iframe.component.css.map */
